// @flow

import { FoxfordService } from 'services/foxford'

import { HOST } from './constants/foxford'

export const sentTaskCompleteDrugoeDelo = async () => {
  const taskId = localStorage.getItem('fox-task-id')
  const user = FoxfordService.user.getCurrentUser()

  if (!user.isLoggedIn()) {
    console.log('Юзер не авторизирован')
    return
  }

  if (taskId !== null && taskId !== undefined && taskId !== '') {
    await FoxfordService.api.post(`${HOST}/api/fastdev/drugoe_delo/tasks/complete`, {
      task_id: taskId,
      task_url: window.location.origin,
    })
  }
}
